
<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['edit-profile']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate"> pages.newRetailer.editProfile</span>
      <mat-icon class="ms-2">person</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['logs']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'viewlogs'"
    >
      <span translate class="translate"> pages.newRetailer.viewLogs</span>
      <mat-icon class="ms-2">summarize</mat-icon>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
